// extracted by mini-css-extract-plugin
export var columnsAuto = "PanelSection-module--columns-auto--41ef2";
export var group = "PanelSection-module--group--ed620";
export var links = "PanelSection-module--links--0b11d";
export var title = "PanelSection-module--title--3c7d3";